import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css'; // Import styles

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        {/* Logo next to the title with adjustable spacing */}
        <Link to="/" className="logo-container">
          <img 
            src="https://visionkraft-bucket.s3.us-east-1.amazonaws.com/sirius-music/logo/logo.png" 
            alt="Sirius Music Group Logo" 
            className="logo"
          />
        </Link>

        {/* Title and tagline */}
        <div className="header-text">
          <h1 className="header-title">🎶 Sirius Music Group</h1>
          <p className="header-tagline">Bringing the Best Sounds to the World</p>
        </div>
      </div>
    </header>
  );
};

export default Header;